var K = Object.defineProperty;
var R = (o, e, r) => e in o ? K(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r;
var p = (o, e, r) => R(o, typeof e != "symbol" ? e + "" : e, r);
const Z = "user_history";
const x = [
  "ar",
  "de",
  "en",
  "es",
  "fr",
  "id",
  "it",
  "ja",
  "ko",
  "nl",
  "pl",
  "pt",
  "pt-br",
  "ru",
  "sv",
  "th",
  "tr",
  "zh"
], h = (o, e) => {
  const r = /* @__PURE__ */ new Date();
  return r.setMonth(Number(o) - 1), new Intl.DateTimeFormat(e, { month: "short" }).format(r);
}, C = (o, e, r, a, t) => e === a ? `${o} - ${r} ${h(e, t)}` : `${o} ${h(e, t)} - ${r} ${h(a, t)}`, L = ({
  dd: o,
  mm: e,
  yy: r,
  lang: a
}) => {
  var m;
  const t = new Date(Number(r), Number(e) - 1, Number(o)), i = (m = (new Intl.DateTimeFormat(a, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(t) || []).find((l) => l.type === "literal")) == null ? void 0 : m.value;
  return [
    o.toString().padStart(2, "0"),
    e.toString().padStart(2, "0"),
    Number(r)
  ].join(i);
}, M = (o, e, r, a) => {
  const t = new Date(Number(r), Number(e) - 1, Number(o));
  t.setDate(t.getDate() + Number(a));
  const n = t.getDate().toString().padStart(2, "0"), s = (t.getMonth() + 1).toString().padStart(2, "0"), i = t.getFullYear().toString();
  return { dayOut: n, monthOut: s, yearOut: i };
}, A = () => `id-${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 10)}`, P = (o) => {
  let e = {};
  return Object.entries(o).forEach(([r, a]) => {
    const t = r.split(".");
    let n = e;
    t.forEach((s, i) => {
      const m = s.match(/(\w+)\[(\d+)\]/);
      if (m) {
        const [, l, c] = m;
        n[l] || (n[l] = []), n[l][c] || (n[l][c] = i === t.length - 1 ? a : {}), n = n[l][c];
      } else
        n[s] || (n[s] = i === t.length - 1 ? a : {}), n = n[s];
    });
  }), e;
}, z = {
  room: "غرفة",
  rooms: "غرف",
  person: "شخص",
  people: "من الأشخاص"
}, F = {
  room: "Zimmer",
  rooms: "Zimmer",
  person: "Person",
  people: "Personen"
}, _ = {
  room: "room",
  rooms: "rooms",
  person: "person",
  people: "people"
}, j = {
  room: "habitación",
  rooms: "habitaciones",
  person: "persona",
  people: "personas"
}, G = {
  room: "chambre",
  rooms: "chambres",
  person: "personne",
  people: "personnes"
}, Y = {
  room: "kamar",
  rooms: "kamar",
  person: "orang",
  people: "orang"
}, J = {
  room: "camera",
  rooms: "camere",
  person: "persona",
  people: "persone"
}, U = {
  room: "部屋",
  rooms: "部屋",
  person: "名",
  people: "名"
}, X = {
  room: "객실",
  rooms: "객의 객실",
  person: "명",
  people: "명"
}, V = {
  room: "kamer",
  rooms: "kamers",
  person: "persoon",
  people: "personen"
}, B = {
  room: "pokój",
  rooms: "pokoi",
  person: "Liczba osób",
  people: "Liczba osób"
}, Q = {
  room: "quarto",
  rooms: "quartos",
  person: "pessoa",
  people: "pessoas"
}, W = {
  room: "номер",
  rooms: "номера",
  person: "человек",
  people: "человек(-а)"
}, q = {
  room: "rum",
  rooms: "rum",
  person: "person",
  people: "personer"
}, tt = {
  room: "ห้อง",
  rooms: "ห้อง",
  person: "คน",
  people: "คน"
}, et = {
  room: "oda",
  rooms: "oda",
  person: "kişi",
  people: "kişi"
}, ot = {
  room: "房间",
  rooms: "间房",
  person: "人",
  people: "人"
}, rt = {
  ar: z,
  de: F,
  en: _,
  es: j,
  fr: G,
  id: Y,
  it: J,
  ja: U,
  ko: X,
  nl: V,
  pl: B,
  pt: Q,
  "pt-br": {
    room: "quarto",
    rooms: "quartos",
    person: "pessoa",
    people: "pessoas"
  },
  ru: W,
  sv: q,
  th: tt,
  tr: et,
  zh: ot
}, at = (o) => {
  let e = 0, r = 0, a = 0;
  const t = parseInt(o["search.roomNumber"], 10);
  for (let n = 0; n < t; n++) {
    const s = parseInt(
      o[`search.roomCriteria[${n}].adultNumber`] || "0",
      10
    ), i = parseInt(
      o[`search.roomCriteria[${n}].childrenNumber`] || "0",
      10
    );
    r += s, a += i, e += s + i;
  }
  return { total: e, adults: r, children: a };
}, E = (o, e = "en") => o.map((r, a) => {
  var i, m, l, c, g, y, b, O, f, I, D, S, N, w, $, v, H, T;
  r.data["search.destination"] && r.data["search.destination.labelSelected"] && delete r.data["search.destination"];
  const { search: t, id: n } = P(r.data);
  if (!t.dayOut || !t.monthOut || !t.yearOut) {
    const u = M(
      t.dayIn,
      t.monthIn,
      t.yearIn,
      t.nightNb
    );
    t.dayOut = u.dayOut, t.monthOut = u.monthOut, t.yearOut = u.yearOut;
  }
  t.dateIn || (t.dateIn = L({
    dd: t.dayIn,
    mm: t.monthIn,
    yy: t.yearIn,
    lang: e
  })), t.dateOut || (t.dateOut = L({
    dd: t.dayOut,
    mm: t.monthOut,
    yy: t.yearOut,
    lang: e
  }));
  const s = at(r.data);
  return {
    indexHistory: a,
    id: n,
    isSelected: !1,
    type: "userHistory",
    destination: {
      code: (i = t.destination) == null ? void 0 : i.code,
      label: ((m = t.destination) == null ? void 0 : m.labelSelected) || t.destination,
      label_en: (l = t.destination) == null ? void 0 : l.label_en,
      type: (c = t.destination) == null ? void 0 : c.type,
      details: st(t, s.total, e)
    },
    geoZone: {
      geoZoneType: (g = t.geoZone) == null ? void 0 : g.geoZoneType,
      geoZoneCode: (y = t.geoZone) == null ? void 0 : y.geoZoneCode,
      location: {
        latitude: (O = (b = t.geoZone) == null ? void 0 : b.location) == null ? void 0 : O.latitude,
        longitude: (I = (f = t.geoZone) == null ? void 0 : f.location) == null ? void 0 : I.longitude
      }
    },
    radius: {
      value: (D = t.radius) == null ? void 0 : D.value,
      unit: (S = t.radius) == null ? void 0 : S.unit
    },
    viewport: {
      northeast: {
        lat: (w = (N = t.viewport) == null ? void 0 : N.northeast) == null ? void 0 : w.lat,
        lng: (v = ($ = t.viewport) == null ? void 0 : $.northeast) == null ? void 0 : v.lng
      },
      southwest: {
        lat: (H = t.viewport) == null ? void 0 : H.southwest.lat,
        lng: (T = t.viewport) == null ? void 0 : T.southwest.lng
      }
    },
    otherDetails: {
      nbRoom: t.roomNumber,
      adultNumber: s.adults,
      childrenNumber: s.children,
      nbPers: s.total,
      dateIn: t.dateIn,
      dateOut: t.dateOut,
      dayIn: t.dayIn,
      monthIn: t.monthIn,
      yearIn: t.yearIn,
      dayOut: t.dayOut,
      monthOut: t.monthOut,
      yearOut: t.yearOut,
      searchRoomCriteria: t.roomCriteria
    }
  };
}), nt = (o) => {
  try {
    const [e] = E([{ data: o }]);
    return o.id = A(), o["search.dateIn"] = e.otherDetails.dateIn, o["search.dateOut"] = e.otherDetails.dateOut, o["search.dayOut"] = e.otherDetails.dayOut, o["search.monthOut"] = e.otherDetails.monthOut, o["search.yearOut"] = e.otherDetails.yearOut, o["search.nbpeoples"] = e.otherDetails.nbPers, o["search.adultNumber"] = e.otherDetails.adultNumber, o["search.childrenNumber"] = e.otherDetails.childrenNumber, o;
  } catch {
    throw new Error(
      "Invalid data input format: please respect the data model published in the doc"
    );
  }
}, st = (o, e, r) => {
  const a = rt[r], t = `${e} ${a[e > 1 ? "people" : "person"]}`, n = Number(o.roomNumber) > 1 ? `, ${o.roomNumber} ${a.rooms}` : "";
  return `${C(
    o.dayIn,
    o.monthIn,
    o.dayOut,
    o.monthOut,
    r
  )}, ${t}` + n;
}, d = class d {
  constructor() {
    p(this, "storageKey", Z);
    p(this, "maxHistoryStored", 3);
    p(this, "lang", "en");
  }
  /**
   * Returns the singleton instance of SearchHistoryService.
   * @returns {SearchHistoryService} The singleton instance.
   */
  static getInstance() {
    return d.instance == null && (d.instance = new d()), d.instance;
  }
  /**
   * Sets the language for transforming search history data.
   * @param {LanguageCode} lang - The language code to set.
   */
  setLang(e) {
    x.includes(e) ? this.lang = e : console.warn(`Invalid language code "${e}". Language not updated.`);
  }
  /**
   * Gets the current language used for transforming search history data.
   * @returns {string} The current language code.
   */
  getLang() {
    return this.lang;
  }
  /**
   * Sets the maximum number of history entries to store.
   * @param {number} value - The maximum number of entries.
   */
  setMaxHistoryStored(e) {
    e > 0 ? this.maxHistoryStored = e : console.warn(
      "Invalid value for maxHistoryStored. It must be greater than 0."
    );
  }
  /**
   * Gets the maximum number of history entries to store.
   * @returns {number} The maximum number of entries.
   */
  getMaxHistoryStored() {
    return this.maxHistoryStored;
  }
  /**
   * Sets the key used for storing search history in local storage.
   * @param {string} key - The storage key to set.
   */
  setStorageKey(e) {
    e && e.trim().length > 0 ? this.storageKey = e : console.warn("Invalid storage key. It must be a non-empty string.");
  }
  /**
   * Gets the key used for storing search history in local storage.
   * @returns {string} The current storage key.
   */
  getStorageKey() {
    return this.storageKey;
  }
  /**
   * Retrieves the search history from local storage.
   * @returns {Array<Record<string, any>>} The search history as an array of records.
   */
  getLocalStorage() {
    return JSON.parse(localStorage.getItem(this.storageKey) || "[]");
  }
  /**
   * Transforms and retrieves the search history.
   * @returns {Record<string, any>} The transformed search history.
   */
  getHistory() {
    return E(this.getLocalStorage(), this.lang).reverse();
  }
  /**
   * Adds a new query to the search history.
   * If the maximum history size is reached, the oldest entry is removed.
   * @param {Record<string, any>} query - The query to be added.
   */
  addToHistory(e) {
    try {
      const r = nt(e), a = this.getLocalStorage();
      a.length >= this.maxHistoryStored && a.shift(), a.push({
        createdAt: (/* @__PURE__ */ new Date()).toLocaleString(),
        data: r
      }), localStorage.setItem(this.storageKey, JSON.stringify(a));
    } catch (r) {
      throw console.error(r), new Error("Error: problem adding history to local storage");
    }
  }
  /**
   * Clears the search history from local storage.
   */
  clearHistory() {
    localStorage.removeItem(this.storageKey);
  }
};
p(d, "instance");
let k = d;
export {
  k as SearchHistoryService
};
